// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Ojnn","insightsList":"newBusinessInsightsMenu_insightsList__2lj_y","active":"newBusinessInsightsMenu_active__3B6dB"};